import { render, staticRenderFns } from "./MainCategoryListItems.vue?vue&type=template&id=6ea0c9fd"
import script from "./MainCategoryListItems.vue?vue&type=script&lang=js"
export * from "./MainCategoryListItems.vue?vue&type=script&lang=js"
import style0 from "./MainCategoryListItems.vue?vue&type=style&index=0&id=6ea0c9fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports